import { render, staticRenderFns } from "./AppSettingsPanel.vue?vue&type=template&id=0316eb5b&scoped=true&"
import script from "./AppSettingsPanel.vue?vue&type=script&lang=js&"
export * from "./AppSettingsPanel.vue?vue&type=script&lang=js&"
import style0 from "./AppSettingsPanel.vue?vue&type=style&index=0&id=0316eb5b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0316eb5b",
  null
  
)

export default component.exports